import { render, staticRenderFns } from "./registration-bonus.vue?vue&type=template&id=52c0eddf"
import script from "./registration-bonus.vue?vue&type=script&lang=js"
export * from "./registration-bonus.vue?vue&type=script&lang=js"
import style0 from "./registration-bonus.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/registration-bonus.vue
// module id = 35D9
// module chunks = 0